export default "__VITE_ASSET__DpJ_0Sdb__"